<template>
    <div id="page" style="background-color: rgba(248, 248, 248, 1);">
        <div class="container">
            <img src="~@/assets/images/menu/碳标签简介.png" style="width: 100%;"/>
        </div>
        <section class="section"  style="background-color: rgba(241, 241, 241, 1);height: 70px;padding: 0;">
            <div class="container">
                <div class="row" style="height: 70px;display:flex;align-items: center;margin:0;">
                    <template v-for="item in key">
                        <div :key="item" class="col-lg-2 col-md-2 active-nav-1" :class="active==item?'active-nav':''" @click="activeChange(item)">{{item}}</div>
                    </template>
                </div>
            </div>
        </section>
        <section class="section" style="padding: 0;padding-bottom:0;"  v-if="active==key[0]">
            <div class="container">
                <span v-html="list&&list.length>0?list[0].textDescribe:''"></span>
            </div>
        </section>
        <section class="section" style="padding: 0;padding-bottom:0;" >
            <div class="container">
                <div class="row" style="padding:20px 0;" v-if="active==key[1]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-12"  :key="index">
                            <div class="text-tip-2"><span style="color:rgba(1, 90, 177, 1);font-weight: 400;">{{item.title}}</span><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span></div>
                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {articleList} from "@/api/home"
    import {getSpecialTime}  from "@/utils/tools"

    export default {
        name: "menu1_2",
        data() {
            return {
                active:"碳标签简介",
                page:{
                    rows:0,
                    currentPage:1
                },
                key:["碳标签简介","碳标签声明报告"],
                list:[]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route.params",this.$route.query)
            this.articleList()
        },
        created() {

        },
        methods: {
            getSpecialTime,
            activeChange(value){
                this.active=value
                this.list = []
                this.page.currentPage = 1
                this.page.rows=10
                this.articleList()
            },
            articleList(){
                let data={
                    parentTitle:"碳标签-标准制定",sonTitle:"碳标签-碳标签简介"
                }
                switch (this.active) {
                    case "碳标签简介":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-碳标签简介"}
                        break;
                    case "碳标签声明报告":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-碳标签声明报告"}
                        break;
                }
                articleList(data).then(res=>{
                    console.log(res)
                    this.list = res.data.records
                    this.page.rows=res.data.total
                })
            }
        }
    }
</script>

<style scoped>

    .container{
        width: 1200px;
        min-width: 375px;
    }
    .active-nav{
        height: 70px;
        background-color: rgba(2, 171, 57, 1);
        color: #ffffff;
    }
    .active-nav-1{
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-content{
        width: 285px;
        background-color: #ffffff;
        padding-bottom:10px;
        margin-bottom: 15px;
    }
    .text-tip-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        padding: 10px 10px 5px 10px;
        height: 100px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-tip-2{
        padding: 5px 10px;
        display: flex;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #888888;
        line-height: 30px;
    }
    .text-tip-2 span{
        flex:1;
    }
    .text-tip-2 span:nth-child(2){
        text-align: right;
    }
</style>
